import React from 'react'

const Button = ({buttonLabel}) => {
  return (
    <>
        <div className="row">
            <div className="col-lg-12">
                <div className="browse-btn2 text-center mt-50">
                    <a href="job_listing.html" className="border-btn2">{buttonLabel}</a>
                </div>
            </div>
        </div>
    </>
  )
}

export default Button